import React from "react";
import WidgetList from "./WidgetList";
import WidgetUpdate from "./WidgetUpdate";
import { Route, Switch } from "react-router-dom";
class Index extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Switch>
        <Route
          path="/widgets/create"
          render={props => (
            <WidgetUpdate
              {...props}
              userPermissions={this.props.userPermissions}
            />
          )}
        />
        <Route
          path="/widgets/create/"
          render={props => (
            <WidgetUpdate
              {...props}
              userPermissions={this.props.userPermissions}
            />
          )}
        />
        <Route
          path="/widgets/update/:id"
          render={props => (
            <WidgetUpdate
              {...props}
              userPermissions={this.props.userPermissions}
            />
          )}
        />
        <Route
          path="/widgets"
          render={props => (
            <WidgetList
              {...props}
              userPermissions={this.props.userPermissions}
            />
          )}
        />
      </Switch>
    );
  }
}

export default Index;
